import React from "react";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import Home from "pages/Home";
import MarketSimulation from "pages/MarketSimulation";
import MsTrader from "pages/MsTrader";
import MsTraderArchitecture from "pages/MsTraderArchitecture";
import Jama from "pages/Jama";
import Hiring from "pages/Hiring";
import Contact from "pages/Contact";
import Imprint from "pages/Imprint";

import NavBar from "components/NavBar";
import Footer from "components/Footer";
import ScrollToTop from "components/ScrollToTop";
import Cookieconsent from "components/Cookieconsent";

const App = () => {
  return (
    <Router basename="">
      <Cookieconsent />
      <ScrollToTop>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/marksim" element={<MarketSimulation />} />
          <Route path="/ms-trader" element={<MsTrader />} />
          <Route
            path="/ms-trader/architecture"
            element={<MsTraderArchitecture />}
          />
          <Route path="/jama" element={<Jama />} />
          <Route path="/judojama" element={<Navigate to="/jama" replace />} />
          <Route path="/hiring" element={<Hiring />} />
          <Route path="/jobs" element={<ToHiring />} />
          <Route path="/careers" element={<ToHiring />} />
          <Route path="/karriere" element={<ToHiring />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="*" element={<DefaultRoute />} />
        </Routes>
        <Footer />
      </ScrollToTop>
    </Router>
  );
};

const DefaultRoute: React.FC = (): React.ReactElement => {
  return <Navigate to={{ pathname: "/" }} />;
};

/** Aliases of /hiring keep their query, so /jobs?lang=fr stays French. */
const ToHiring: React.FC = (): React.ReactElement => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/hiring", search }} replace />;
};

export default App;
